// react-router-dom components
import { Link } from 'react-router-dom';

// prop-types is a library for typechecking of props.
import PropTypes from 'prop-types';

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import Icon from '@mui/material/Icon';

// Argon Dashboard 2 MUI components
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';

function Breadcrumbs({ icon, title, route, light }) {
  const routes = route.slice(0, -1);

  return (
    <ArgonBox mr={{ xs: 0, xl: 8 }}>
      <div style={{ display: '-webkit-flex', alignItems: 'center' }}>
        <MuiBreadcrumbs
          sx={{
            '& .MuiBreadcrumbs-separator': {
              color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
            },
          }}
        >
          <Link to="/">
            <ArgonTypography
              component="span"
              variant="body2"
              color={light ? 'white' : 'dark'}
              opacity={light ? 0.8 : 0.5}
              sx={{ lineHeight: 0 }}
            >
              <Icon>{icon}</Icon>
            </ArgonTypography>
          </Link>
          {routes.map((el) => (
            <Link to={`/${el}`} key={el}>
              <ArgonTypography
                component="span"
                variant="button"
                fontWeight="regular"
                textTransform="capitalize"
                color={light ? 'white' : 'dark'}
                opacity={light ? 0.8 : 0.5}
              >
                {el}
              </ArgonTypography>
            </Link>
          ))}
          <ArgonTypography
            variant="button"
            fontWeight="regular"
            textTransform="capitalize"
            color={light ? 'white' : 'dark'}
          >
            {title.replace('-', ' ')}
          </ArgonTypography>
        </MuiBreadcrumbs>
        {/* <span style={{ marginLeft: '1rem' }}>
          <ArgonTypography fontWeight="bold" textTransform="capitalize" variant="h6" color={light ? 'white' : 'dark'}>
            {title.replace('-', ' ')}
          </ArgonTypography>
        </span> */}
      </div>
    </ArgonBox>
  );
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
  light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;
